import { Empty, List, Space, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function NodeLinkList({ nodes = [], relationships = [], focusNode, focusLink }) {
  const hasRelationships = relationships.length > 0;

  if (nodes.length === 0) {
    return <Empty description="No linked items available." />;
  }

  return (
    <List
      className="detail-box__list"
      dataSource={hasRelationships? relationships : nodes}
      renderItem={(nodeLink, index) => {
        const itemTitle = hasRelationships ? (
          <Space size={8} wrap>
            <Text strong>{nodeLink.source.id || 'Unknown'}</Text>
            <ArrowRightOutlined style={{ color: '#0f766e', fontSize: 12 }} />
            <Text strong>{nodeLink.target.id || 'Unknown'}</Text>
          </Space>
        ) : (
          <Text strong>{nodeLink?.title || 'Untitled Node'}</Text>
        );

        return (
          <List.Item
            className="detail-box__list-item"
            onClick={() => {
              if (hasRelationships) {
                focusLink(nodeLink);
              } else {
                focusNode(nodeLink);
              }
            }}
          >
            <List.Item.Meta
              title={itemTitle}
            />
          </List.Item>
        );
      }}
    />
  );
}
